import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { getRegion } from '../utils/Region';
import * as routesPaths from './RouteConstants';
import { PublicRoute } from './components/PublicRoute';
import { PrivateRoute } from './components/PrivateRoute';
import NewMusicPage from 'containers/MusicPage/components/NewMusicPage/NewMusicPage';
import HomeUser from 'modules/HomeUserRouteView';
import MyAccount from 'containers/MyAccount';
import NavigationWrapper from 'components/NavigationWrapper';
import VCard from '../containers/Vcard/DetailPage';
import SearchPage from '../containers/NewSearchPage';
import Mundial2026 from 'containers/Mundial2026';

//----LAZY ROUTES----
const CompleteYourInfo = lazy(() => import('../containers/CompleteYourInfo'));
const Tutorials = lazy(() => import('../containers/Tutorials'));
const Faqs = lazy(() => import('../containers/Faqs'));
const MinReq = lazy(() => import('../containers/MinReq'));
const VideoTutorials = lazy(() => import('../modules/VideoTutorialsView'));
const Tutoriales = lazy(() => import('../modules/TutorialsView'));
const TalentPage = lazy(() => import('../containers/NewSearchTalentPage'));
const CardDownload = lazy(() => import('../modules/CardRouteDownload'));
const Reminder = lazy(() => import('../modules/login/ReminderRouteView'));
const ResetPassword = lazy(() => import('../modules/ResetPasswordRouteView'));
const PlayerInApp = lazy(() => import('../modules/PlayerInAppView'));
const Preferences = lazy(() => import('../containers/PreferencesPage'));
const MusicPage = lazy(() => import('../containers/MusicPage'));
const PlaylistDetail = lazy(() => import('../containers/MusicDetailPage'));
const MusicPlayer = lazy(() => import('../containers/MusicPlayerPage'));
const TermsRouteView = lazy(() => import('../modules/TermsRouteView'));
const AppleAttach = lazy(() => import('../modules/AppleLoginView'));
const AppleLogin = lazy(() =>
  import('../containers/Login/components/AppleLogin'),
);
const MundialPlayerVcard = lazy(() =>
  import('../containers/VCardMundial/PlayerVCard'),
);
const MundialMatchVcard = lazy(() =>
  import('../containers/VCardMundial/MatchVCard'),
);
const MundialTeamVcard = lazy(() =>
  import('../containers/VCardMundial/TeamVCard'),
);
const IpTelmexActivate = lazy(() =>
  import('../modules/IpTelmexActivateRouteView'),
);
const IpTelmexConfirm = lazy(() =>
  import('../modules/IpTelmexConfirmRouteView'),
);
const TemporalRegister = lazy(() =>
  import('../containers/TemporalRegisterPage'),
);
const FooterLinkCotainer = lazy(() =>
  import('../containers/FooterLinkContainer'),
);
const WhatIncludes = lazy(() => import('../containers/WhatIncludesContainer'));
const CommercialLanding = lazy(() => import('../containers/CommercialLanding'));
const DetailPageEvent = lazy(() => import('../containers/DetailPageEvent'));
const Help = lazy(() => import('../containers/Help'));
const TutorialsGrid = lazy(() => import('../components/HelpCenter/TutorialsGrid'));
const InstallationManuals = lazy(() => import('../components/HelpCenter/InstallationManuals'));
const ManualViewer = lazy(() => import('../components/HelpCenter/ManualViewer'));
const Installer = lazy(() => import('../components/HelpCenter/Installer'));
const InstallerManual = lazy(() => import('../components/HelpCenter/Installer/InstallerManual'));
const InstallerDevice = lazy(() => import('../components/HelpCenter/Installer/InstallerDevice'));
const InstallerVideo = lazy(() => import('../components/HelpCenter/Installer/InstallerVideo'));
const Device = lazy(() => import('../components/HelpCenter/Device'));
const TutorialPlayer = lazy(() => import('../components/HelpCenter/TutorialPlayer'));
const PBIDeepLinkView = lazy(() => import('../modules/PBIDeepLinkView'));

//----ARREGLO DE SUB RUTAS----
export const mainSubRoutes = [
  {
    path: routesPaths.NODE_MUNDIAL_2026
    ,
    element: (
      <NavigationWrapper>
        <Mundial2026 />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.HOME_USER,
    element: (
      <NavigationWrapper>
        <HomeUser />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.COMPLETE_YOUR_INFO,
    element: (
      <NavigationWrapper>
        <CompleteYourInfo />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.CARD_NODE_ID,
    element: (
      <NavigationWrapper>
        <VCard />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.CARD_NODE,
    element: (
      <NavigationWrapper>
        <VCard />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.TUTORIALS,
    element: (
      <NavigationWrapper>
        <Tutorials />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.HELP_CENTER,
    element: <Help />,
  },
  {
    path: routesPaths.VIDEO_TUTORIAL_PLAY,
    element: <TutorialPlayer />,
  },
  {
    path: routesPaths.VIDEO_TUTORIALS_DEVICE,
    element: <Device />,
  },
  {
    path: routesPaths.VIDEO_TUTORIALS,
    element: <TutorialsGrid />,
  },
  {
    path: routesPaths.INSTALLATION_MANUAL_VIEW,
    element: <ManualViewer />,
  },
  {
    path: routesPaths.INSTALLATION_MANUALS,
    element: <InstallationManuals />,
  },
  {
    path: routesPaths.INSTALLER_VIDEO_PLAY,
    element: <InstallerVideo />,
  },
  {
    path: routesPaths.INSTALLER_VIDEO_DEVICE,
    element: <InstallerDevice />,
  },
  {
    path: routesPaths.INSTALLER_MANUAL,
    element: <InstallerManual />,
  },
  {
    path: routesPaths.INSTALLER,
    element: <Installer />,
  },
  {
    path: routesPaths.FIRETV_SUPPORT,
    element: <FooterLinkCotainer textKey="support_firetv_text" />,
  },
  {
    path: routesPaths.VIDEO_TUTORIALS,
    element: <FooterLinkCotainer textKey="tenv_full_text" />,
  },
  {
    path: routesPaths.FINAL_USER_LICENSE,
    element: <FooterLinkCotainer textKey="luf_full_text" />,
  },
  {
    path: routesPaths.TERMS_CONDITIONS,
    element: <FooterLinkCotainer textKey="tyc_full_text" />,
  },
  {
    path: routesPaths.POLITICAS_DE_PRIVACIDAD,
    element: <FooterLinkCotainer textKey="pp_full_text" />,
  },
  {
    path: routesPaths.PROM_TERMS,
    element: <FooterLinkCotainer textKey="prom_terms_full_text" />,
  },
  {
    path: routesPaths.FAQS,
    element: <Faqs />,
  },
  {
    path: routesPaths.MIN_REQ,
    element: <MinReq />,
  },
  {
    path: routesPaths.IP_TELMEX_REGISTER,
    element: <TemporalRegister />,
  },
  {
    path: routesPaths.IP_TELMEX_CONFIRM,
    element: <IpTelmexConfirm />,
  },
  {
    path: routesPaths.IP_TELMEX_ACTIVATE,
    element: <IpTelmexActivate />,
  },
  {
    path: routesPaths.TUTOVIDEO,
    element: <VideoTutorials />,
  },
  {
    path: routesPaths.TUTOS,
    element: <Tutoriales />,
  },
  {
    path: routesPaths.SEARCH,
    element: (
      <NavigationWrapper>
        <SearchPage />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.TALENT,
    element: <TalentPage />,
  },
  {
    path: routesPaths.CARD_DOWNLOAD,
    element: (
      <NavigationWrapper>
        <CardDownload />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.REMINDER,
    element: <Reminder />,
  },
  {
    path: routesPaths.RESET_PASSWORD,
    element: (
      <NavigationWrapper>
        <ResetPassword />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.PLAYERINAPP,
    element: <PlayerInApp />,
  },
  {
    path: routesPaths.MATCH_CARD,
    element: (
      <NavigationWrapper>
        <MundialMatchVcard />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.TEAM_CARD,
    element: (
      <NavigationWrapper>
        <MundialTeamVcard />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.PLAYER_CARD,
    element: (
      <NavigationWrapper>
        <MundialPlayerVcard />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.APPLEATTACH,
    element: (
      <NavigationWrapper>
        <AppleAttach />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.APPLEIDLOGIN,
    element: <AppleLogin />,
  },
  {
    path: routesPaths.PREFERENCES,
    element: <PrivateRoute component={Preferences} />,
  },
  {
    path: routesPaths.WHAT_INCLUDES_ROUTE,
    element: <WhatIncludes />,
  },
  {
    path: routesPaths.PLAN_SELECT_ROUTE,
    element: <CommercialLanding />,
  },

  {
    path: routesPaths.MY_ACCOUNT,
    element: <PrivateRoute component={MyAccount} />,
  },
  {
    path: routesPaths.SET_CONTROL_PIN_TEST,
    element: <PrivateRoute component={MyAccount} />,
  },
  {
    path: routesPaths.ROOT_MUSICA,
    element: <Navigate to={`/${getRegion()}/cmusica/browse`} />,
  },
  {
    path: routesPaths.ROOT_MUSICA1,
    element: <Navigate to={`/${getRegion()}/cmusica/browse`} />,
  },
  {
    path: routesPaths.BROWSE_MUSICA,
    element: <PrivateRoute component={NewMusicPage} />,
  },
  {
    path: routesPaths.PLAYLIST_DETAIL,
    element: <PrivateRoute component={PlaylistDetail} />,
  },
  {
    path: routesPaths.PLAYLIST_DETAIL_CAROUSEL,
    element: <PrivateRoute component={PlaylistDetail} />,
  },
  {
    path: routesPaths.PLAYER_MUSICA,
    element: <PrivateRoute component={MusicPlayer} />,
  },
  {
    path: routesPaths.PLAYER_MUSICA_CAROUSEL,
    element: <PrivateRoute component={MusicPlayer} />,
  },
  {
    path: routesPaths.EVENT_CARD_NODE_ID,
    element: (
      <NavigationWrapper>
        <DetailPageEvent />
      </NavigationWrapper>
    ),
  },
  {
    path: routesPaths.TERMS,
    element: <TermsRouteView />,
  },
];
